import React, { useCallback } from 'react';
import { GridControlsDropDownTemplateProps } from 'models/grid';
import { MenuItem } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';
import { GridModel } from '../models';
import { useGridMedicalPrescriptions } from '../hooks';

interface Props extends GridControlsDropDownTemplateProps<GridModel> {}
export const ControlEdit: React.FC<React.PropsWithChildren<Props>> = ({ data, handleClose }) => {
  const { t } = useTranslate();
  const disabled = !Boolean("production" === 'development' || !data?.isCompleted);
  const { onTasks } = useGridMedicalPrescriptions();

  const onClick = useCallback(() => {
    onTasks([['onHandle', { type: 'edit', id: data.id, data }]]);
    handleClose();
  }, [handleClose, data, onTasks]);

  return (
    <MenuItem onClick={onClick} disabled={disabled}>
      {t('edit')}
    </MenuItem>
  );
};
